import React, { useCallback, useEffect, useState } from 'react'
import Spinner from '../../Spinner'

import UserWishlistProductItem from '../UserWishlistProductItem'

import * as S from './styles'

interface IDataProductProps {
    items: {
        images: {
            imageUrl: string;
        }[]

        sellers: {
            sellerName: string;
            commertialOffer: {
                Price: number;
            };
        }[]
    }[];
    linkText: string;
    productName: string;
    productReference: string;
    productId: string;
}

interface IUserWishlistProductsItemsProps {
    products: IDataProductProps[];
    loading: boolean;
    isEmpty: boolean;
    onClickRemoveButtonHandler: (linkText: string) => void;
}

const UserWishlistProductsItems: React.FC<IUserWishlistProductsItemsProps> = ({
    products,
    onClickRemoveButtonHandler,
    loading,
    isEmpty
}) => {

    const [productsSorted, setProductsSorted] = useState<IDataProductProps[]>([])

    const onOpenWishListHandler = useCallback(() => {

        products.sort(function (a: IDataProductProps, b: IDataProductProps) {
            if (a.productId < b.productId) return 1
            if (a.productId > b.productId) return -1
            return 0
        })

        setProductsSorted(products)
    }, [products])

    useEffect(() => {
        onOpenWishListHandler()
    }, [onOpenWishListHandler])

    return (
        <S.Container>
            <S.Title> Itens </S.Title>
            <S.UserWishlistItems>
                {
                    loading ?
                        <Spinner />
                        :
                        productsSorted.map((product) => (
                            <UserWishlistProductItem key={product.productReference + Math.random()} onClickRemoveButtonHandler={onClickRemoveButtonHandler} {...product} />
                        ))
                }

                {
                    !loading && isEmpty && <S.IsEmptyMessage> Adicione algum item na sua lojinha!</S.IsEmptyMessage>
                }

            </S.UserWishlistItems>
        </S.Container>
    )
}



export default UserWishlistProductsItems